<form [formGroup]="fG">
  <div class="e-input-group e-float-icon-left {{ style !== 'headless' ? 'e-float-input' : '' }} {{ fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '' }} {{ iconClickType === 'both' ? 'hover-effect' : iconClickType === 'front' ? 'hover-effect-left' : '' }} {{ wrapperClass }}">
    <!-- Front Icon Section -->
    @if (iconFront) {
      @if (iconFrontTooltip) {
        <ejs-tooltip opensOn='Click' [content]="iconFrontTooltip" class="e-input-group-icon mts-icon">
          {{ iconFront }}
        </ejs-tooltip>
      }
      @if (!iconFrontTooltip) {
        <span (click)="canClickFrontIcon() ? onIconFrontClicked() : null" class="e-input-group-icon mts-icon" [class.icon-clickable]="canClickFrontIcon()" [class.icon-disabled]="!canClickFrontIcon()">{{ iconFront }}</span>
      }
    }


    <!-- Input Section with Close Icon and Dropdown -->
    <div class="e-input-in-wrap asterisk {{ iconClickType === 'back' ? 'hover-effect-right' : ''}}">
      @if (style !== 'headless') {
        <input [type]="type" [formControlName]="fCN" (blur)="onBlur()" (keyup.enter)="onReturnKeyPress()" (input)="onInput($event)" class="e-input {{ cssClass }}" [attr.aria-placeholder]="placeholder ? placeholder : label" [attr.aria-labelledby]="label" />
      }
      @if (style === 'headless') {
        <input [type]="type" [formControlName]="fCN" (blur)="onBlur()" (keyup.enter)="onReturnKeyPress()" (input)="onInput($event)" class="e-input {{ cssClass }}" [placeholder]="placeholder" [attr.aria-placeholder]="placeholder ? placeholder : label" [attr.aria-labelledby]="label" />
      }
      @if (style !== 'headless') {
        <span class="e-float-line"></span>
      }
      @if (style !== 'headless') {
        <label [ngClass]="{'e-label-top': fG.controls[fCN].value !== '' && style === 'inline', 'e-label-bottom':  fG.controls[fCN].value === '' && style === 'inline'}" class="e-float-text">{{ label }}</label>
      }

      <!-- Back Icon (Close Icon) -->
      @if (iconBack && (type !== 'search' || fG.controls[fCN].value?.length > 0)) {
        @if (iconBackTooltip) {
          <ejs-tooltip opensOn='Click' [content]="iconBackTooltip" class="e-input-group-icon mts-icon formInputTooltip">
            {{ iconBack }}
          </ejs-tooltip>
        }
        @if (!iconBackTooltip) {
          <span (click)="canClickBackIcon() ? onIconBackClicked() : null" class="e-input-group-icon mts-icon back-icon" [class.icon-clickable]="canClickBackIcon()" [class.icon-disabled]="!canClickBackIcon()">{{ iconBack }}</span>
        }
      }

      <!-- Conditionally Render Dropdown List -->
      <div class="searchFilterDopdown">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  @if (hasErrorField) {
    <div class="error-label" role="alert">
      {{ errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? errorText : '' }}
    </div>
  }
</form>
